import { useEffect, useRef } from "react";

import { useSearchParams } from "next/navigation";

import { useStore } from "@/store";
import { consumeTeamDialogLink, parseTeamDialogLink } from "@/utils/teamDialogLink";

/**
 * Opens the dialog on the tab and team named by the page's query params (see
 * `withTeamDialogLink`) once the user's teams are loaded, then drops the params from the url.
 */
export function useOpenTeamDialogFromQuery() {
  const { dialog, teams } = useStore();
  const queryParams = useSearchParams();
  const pendingRef = useRef(parseTeamDialogLink(queryParams));
  const isTeamsLoaded = Boolean(teams.currentTeam);

  useEffect(() => {
    const link = pendingRef.current;
    if (!link || !isTeamsLoaded) return;
    pendingRef.current = null;

    const team = teams.userTeams.find(({ permalink }) => permalink === link.teamPermalink);
    dialog.teamDialog.open(team, link.tab);
    consumeTeamDialogLink();
  }, [dialog, teams, isTeamsLoaded]);
}
